interface EqualHousingLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const EqualHousingLogo = ({ className = "", size = "md" }: EqualHousingLogoProps) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <svg
      viewBox="0 0 100 100"
      className={`${sizeClasses[size]} ${className}`}
      fill="currentColor"
      aria-label="Equal Housing Opportunity"
    >
      {/* House outline */}
      <path d="M50 5 L95 45 L95 95 L5 95 L5 45 Z" fill="none" stroke="currentColor" strokeWidth="3" />
      {/* Roof */}
      <path d="M50 5 L95 45 L5 45 Z" fill="none" stroke="currentColor" strokeWidth="3" />
      {/* Equal sign */}
      <rect x="25" y="55" width="50" height="8" />
      <rect x="25" y="70" width="50" height="8" />
    </svg>
  );
};

export default EqualHousingLogo;
